import { render, staticRenderFns } from "./AssemblyArea.vue?vue&type=template&id=2f6e4780&"
import script from "./AssemblyArea.vue?vue&type=script&lang=js&"
export * from "./AssemblyArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports